import { assertNever } from '@kofno/piper';
import { action, makeObservable, observable } from 'mobx';
import { ProductTypeFilterOptionData } from '../../../../../Types';
import {
  ProductTypeFilter,
  ProductTypeFilterOptions,
  State,
  blank,
  closed,
  opened,
  updatingProductType,
} from './Types';

class ProductTypeFilterStore {
  @observable
  state: State;

  readonly initialFilterValues: ProductTypeFilter;

  constructor(filters: ProductTypeFilterOptionData[]) {
    makeObservable(this);
    this.initialFilterValues = {
      productTypes: filters.map((d) => d.name),
    };

    this.state = blank(this.initialFilterValues);
  }

  @action
  open = () => {
    switch (this.state.kind) {
      case 'closed':
        this.state = opened(this.state);
        break;
      case 'opened':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  close = () => {
    switch (this.state.kind) {
      case 'opened':
        this.state = closed(this.state);
        break;
      case 'closed':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  filterAllValues = (value: ProductTypeFilterOptions) => {
    switch (this.state.kind) {
      case 'opened':
        this.state = updatingProductType(this.state, value, this.initialFilterValues.productTypes);
        break;
      case 'closed':
        break;
      default:
        assertNever(this.state);
    }
  };
}

export default ProductTypeFilterStore;
